import React, { FC, useState, useMemo } from "react";
import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { WindowData, restrictedModalItems } from "../utils";
import { WebsitesAndAppsListModal } from "@/components/WebsitesAndAppsListModal";
import { User } from "@/js/utils/userUtils";

interface Props {
	screenshotData: WindowData;
	isMonitorMode: boolean;
	isStudentClaimed: boolean;
	isClassActive: boolean;
	student: User;
	forceCloseTab: (tabId: string, force: boolean) => void;
	canCloseTab: boolean;
}

export const RestrictedAppsModal: FC<Props> = ({ screenshotData, isMonitorMode, isClassActive, student, ...props }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const restrictedItems = useMemo(() => restrictedModalItems(screenshotData), [screenshotData]);

	const openRestrictedModal = (): void => {
		setOpen(true);
	};

	const closeRestrictedAppsModal = () => {
		setOpen(false);
	};

	return (
		<>
			<Button
				data-testid="button-restricted-apps-modal"
				variant={"link"}
				backgroundColor={"transparent"}
				textDecoration={"underline"}
				textColor={"var(--primary-color)"}
				display={"flex"}
				paddingY={"2"}
				onClick={() => openRestrictedModal()}
				_hover={{ backgroundColor: "transparent" }}
				mx={"auto"}
			>
				{t("classroomDetails.viewRestrictedWebsiteApp")}
			</Button>
			<WebsitesAndAppsListModal
				title={t("classroomDetails.restrictedWebsitesAndApplications")}
				open={open}
				restrictedItems={restrictedItems}
				items={[]}
				studentUsername={student.username}
				onClose={closeRestrictedAppsModal}
				forceCloseTab={props.forceCloseTab}
				canCloseTab={props.canCloseTab}
				classIsActive={isClassActive}
				isMonitorMode={isMonitorMode}
				isStudentClaimed={props.isStudentClaimed}
			/>
		</>
	);
};
